import { AnimationBaseController, IAnimationControllerConfiguration, Inject, ModelEvents, TextureList } from '@denishussar/html5-game-engine';
import { GameModel, GameMoveableObstacleTypeEnum, RoadObjectType } from '../../../../Models/GameModel';
import { AnimationContents } from '../../../../../AnimationContents';
import { GameLogic } from '../../../../Logic/GameLogic';
import { GameMoveableObstacleProjectionController } from './GameMoveableObstacleProjectionController';
import { remapValue } from '../../../../Common/Utils';
import { Point, Rectangle } from 'pixi.js';
import { VFXController } from '../VFX';
import { LevelEvents } from '../../../../Constants/Events';
import { PoliceSpine, PoliceAnims } from '../PoliceSpine';
import { VFXMoney } from '../VFXMoney';
import { ColliderController } from '../Collider';

export interface IGameMoveableObstacleControllerOptions {
    type: GameMoveableObstacleTypeEnum;
    projectionController: GameMoveableObstacleProjectionController;
}



export class GameMoveableObstacleController extends AnimationBaseController {
    $model: GameModel;
    public police: PoliceSpine;
    public destroyed: boolean;

    private _projectionScale: number[] = [0.2, 6.5];

    private _type: GameMoveableObstacleTypeEnum = GameMoveableObstacleTypeEnum.none;
    private _projectionController: GameMoveableObstacleProjectionController;

    public globalProjectionPoint: Point;
    public localPoint: Point;
    public localMargin: Point = new Point();

    public currentFrameLabel: string | number = null;
    public currentLightFrameLabel: string = null;

    private eventDispatched;

    public scaleInvertor = false;

    private collider: ColliderController;

    public constructor(
        @Inject private _options: IGameMoveableObstacleControllerOptions,
        @Inject private _gameLogic: GameLogic,
        @Inject private events: ModelEvents,
    ) {
        super('GameMoveableObstacleController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'obstacle',
        };
    }

    onDestroy() {
        this.events.dispatch(this.$model, LevelEvents.hideCollectable, this.getType());
    }

    protected onInitialize(): void {
        this.collider = this.addChildController(
            {
                controller: ColliderController,
            }, 
            "collider"
        ) as ColliderController;
        this.collider.gotoAndStop(this._options.type);
        this._type = this._options.type;
        this._projectionController = this._options.projectionController;

        this.visible = false;


        this.gotoAndStop(this._type);
        this.setDirection(0);

        if (this._type == GameMoveableObstacleTypeEnum.police) {
            this.police = new PoliceSpine(0, this.$model);
            this.display.addChild(this.police.container);
        }
        if (this._type == GameMoveableObstacleTypeEnum.policeCrown) {
            this.police = new PoliceSpine(1, this.$model);
            this.display.addChild(this.police.container);
        }
        this.display["controller"] = this;

        setTimeout(() => {
            switch (this._options.type) {
                case GameMoveableObstacleTypeEnum.gelandewagen:
                    this.display.hitArea = new Rectangle(-200, -250, 400, 500)
                    break;
            }

        }, 0)

        this.display.getBounds = this.collider.display.getBounds.bind(this.collider.display);
    }

    protected onResize(width: number, height: number, scale: number) {
    }

    public getObjectType(): RoadObjectType {
        return RoadObjectType.movableObstacle;
    }

    protected onUpdate(frameRate: number) {
        if (this._projectionController.display.position.y <= 0) {
            this.visible = false;
        }
        else {
            this.visible = true;
            if (!this.eventDispatched) {
                this.eventDispatched = true;
                this.events.dispatch(this.$model, LevelEvents.showCollectable, this.getType());
            }
        }


        this.globalProjectionPoint = this._projectionController.display.parent.toGlobal(this._projectionController.display.position);
        this.localPoint = this.display.parent.toLocal(this.globalProjectionPoint, this.renderer.stage);

        this.display.x = this.localPoint.x;
        this.display.y = this.localPoint.y + this.localMargin.y;
        this.display.scale.set(remapValue(this.globalProjectionPoint.y,
            this.renderer.renderer.height * 0.25, this.renderer.renderer.height,
            this._projectionScale[0] * GameModel.SCALE, this._projectionScale[1] * GameModel.SCALE,
        ));

        if (this.scaleInvertor) {
            this.display.scale.x = -this.display.scale.x;
        }
        if(this._projectionController)
        this.alpha = Math.min(1, this.getProjectionController().display.y/500)
    }

    public setDirection(dir: number): void {
        switch (dir) {
            case -1:
                //this.gotoAndStopByQuery('car', 'left');
                break;
            case 0:
                //this.gotoAndStopByQuery('car', 'mid');
                break;
            case 1:
                //this.gotoAndStopByQuery('car', 'right');
                break;
        }
    }


    setProjection(a, b) {
        if (this.localPoint) {
            const margin = 180;

            switch (this.$model.playerRoadIndex - this.getRoadIndex()) {
                case 0:
                    this.gotoAndStopByQuery(this.getType(), 'forward');

                    switch (this.getType()) {
                        case GameMoveableObstacleTypeEnum.police:
                        case GameMoveableObstacleTypeEnum.policeCrown:
                            // this.playLights('light_idle');
                            this.police.setAnimation(PoliceAnims.idle, true);
                            break;
                    }

                    this.localMargin.x = 0;
                    break;
                case 1:
                    if (this.localPoint.y > a) {
                        this.gotoAndStopByQuery(this.getType(), 'left');

                        switch (this.getType()) {
                            case GameMoveableObstacleTypeEnum.police:
                            case GameMoveableObstacleTypeEnum.policeCrown:
                                // this.playLights('light_left_1');
                                this.police.setAnimation(PoliceAnims.left1, true);
                                break;
                        }

                    } else {
                        this.gotoAndStopByQuery(this.getType(), 'forward');

                        switch (this.getType()) {
                            case GameMoveableObstacleTypeEnum.police:
                            case GameMoveableObstacleTypeEnum.policeCrown:
                                // this.playLights('light_idle');
                                this.police.setAnimation(PoliceAnims.idle, true);
                                break;
                        }
                    }
                    this.localMargin.x = 0;
                    break;
                case 2:
                    if (this.localPoint.y > b) {
                        this.gotoAndStopByQuery(this.getType(), 'left34');

                        switch (this.getType()) {
                            case GameMoveableObstacleTypeEnum.police:
                            case GameMoveableObstacleTypeEnum.policeCrown:
                                // this.playLights('light_left_2');
                                this.police.setAnimation(PoliceAnims.left2, true);
                                break;
                        }

                        this.localMargin.x = -margin;
                    } else {
                        this.gotoAndStopByQuery(this.getType(), 'left');

                        switch (this.getType()) {
                            case GameMoveableObstacleTypeEnum.police:
                            case GameMoveableObstacleTypeEnum.policeCrown:
                                // this.playLights('light_left_1');
                                this.police.setAnimation(PoliceAnims.left1, true);
                                break;
                        }

                        this.localMargin.x = 0;
                    }
                    break;
                case -1:
                    if (this.localPoint.y > a) {
                        this.gotoAndStopByQuery(this.getType(), 'right');

                        switch (this.getType()) {
                            case GameMoveableObstacleTypeEnum.police:
                            case GameMoveableObstacleTypeEnum.policeCrown:
                                // this.playLights('light_right_1');
                                this.police.setAnimation(PoliceAnims.right1, true);
                                break;
                        }

                    } else {
                        this.gotoAndStopByQuery(this.getType(), 'forward');

                        switch (this.getType()) {
                            case GameMoveableObstacleTypeEnum.police:
                            case GameMoveableObstacleTypeEnum.policeCrown:
                                // this.playLights('light_idle');
                                this.police.setAnimation(PoliceAnims.idle, true);
                                break;
                        }

                    }
                    this.localMargin.x = 0;
                    break;
                case -2:
                    if (this.localPoint.y > b) {
                        this.gotoAndStopByQuery(this.getType(), 'right34');

                        switch (this.getType()) {
                            case GameMoveableObstacleTypeEnum.police:
                            case GameMoveableObstacleTypeEnum.policeCrown:
                                // this.playLights('light_right_2');
                                this.police.setAnimation(PoliceAnims.right2, true);
                                break;
                        }

                        this.localMargin.x = margin;
                    } else {
                        this.gotoAndStopByQuery(this.getType(), 'right');

                        switch (this.getType()) {
                            case GameMoveableObstacleTypeEnum.police:
                            case GameMoveableObstacleTypeEnum.policeCrown:
                                // this.playLights('light_right_1');
                                this.police.setAnimation(PoliceAnims.right2, true);
                                break;
                        }

                        this.localMargin.x = 0;
                    }
                    break;
            }
        }
    }

    public getType(): GameMoveableObstacleTypeEnum {
        return this._type;
    }

    public getIndex(): number {
        return this._projectionController.getIndex();
    }

    public getRoadIndex(): number {
        return this._projectionController.getRoadIndex();
    }

    public getProjectionController(): GameMoveableObstacleProjectionController {
        return this._projectionController;
    }

    public gotoAndStopByQuery(query: string, positionOrLabel?: number | string, inherit?: boolean) {
        if (this.currentFrameLabel !== positionOrLabel) {
            this.currentFrameLabel = positionOrLabel;
            super.gotoAndStopByQuery(query, positionOrLabel, false);

        }
    }

    public playLights(frame: string): void {
        // if (this.currentLightFrameLabel !== frame) {
        //     this.currentLightFrameLabel = frame;

        //     const query = `${this.getType()}.light.${frame}`;
        //     this.getDisplayObjectByQuery(query)[0].visible = false
        //     // this.gotoAndPlayByQuery(query, 0, true, false);

        //     // console.log('light frame', query, this.getDisplayObjectByQuery(query)[0]);
        // }
    }

    public boom(cb: () => void) {
        if (this.destroyed) return;

        this.display.children.forEach(c => c.visible = false);

        this.destroyed = true;
        const vfx = new VFXController(this.$model);
        const moneyVfx = new VFXMoney(this.$model);
        this.display.addChild(vfx.container);
        this.display.addChild(moneyVfx.container);
        let counter = 0;
        vfx.spine.state.addListener({
            complete: track => () => {
                // console.log("call callback");
                cb();
            }
        });
        vfx.setAnimation("fx_explosion", false);

    }
}
